const initialState = {
    "paso": 0,
    "apaterno": "",
    "amaterno": "",
    "nombres": "",
    "tipo": "",
    "extension": "",
    "lada": "",
    "telefono": ""
}

export function asistidoRdc(state = initialState, action) {
    switch (action.type) {
        case "REGISTRO_ASISTIDO_PASO": 
            return {...state,
                "paso": state.paso
            };
        case "REGISTRO_ASISTIDO_SIGUIENTE_PASO": 
            return {...state,
                "paso": state.paso + 1
            };
        case "REGISTRO_ASISTIDO_SIGUIENTE_ANTERIOR": 
            return {...state,
                "paso": state.paso - 1
            };
        case "REGISTRO_ASISTIDO_COMPLETAR":
            return {...state,
                "apaterno": action.apaterno,
                "amaterno": action.amaterno,
                "nombres": action.nombres
            };
        case "REGISTRO_ASISTIDO_INCONVENIENTES":
            return {...state,
                "tipo": action.tipo,
                "extension": action.extension,
                "lada": action.lada,
                "telefono": action.telefono
            };
        case "LIMPIAR_REGISTRO_ASISTIDO":
            return {...state,
                "paso": 0,
                "apaterno": "",
                "amaterno": "",
                "nombres": "",
                "tipo": "",
                "extension": "",
                "lada": "",
                "telefono": ""
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/registro-asistido/reducer.js